import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoadingService } from '../services/loading.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login-wrapper',
  templateUrl: './login-wrapper.component.html',
  styleUrls: ['./login-wrapper.component.scss'],
  standalone: false
})
export class LoginWrapperComponent implements OnInit, OnDestroy {
  isLoading$ = this.loadingService.loading$;
  private destroy$ = new Subject<void>();

  constructor(
    private loadingService: LoadingService,
    private router: Router
  ) {
    // Show spinner immediately when login component is constructed
    // This eliminates the blank screen before the component fully loads
    this.loadingService.show();
  }

  ngOnInit(): void {
    // Handle all router events to manage spinner state
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          // Show spinner when navigation starts
          if (event.url.includes('login')) {
            this.loadingService.show();
          } else {
            // Navigating away from login - hide spinner
            this.loadingService.hide();
          }
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          // Hide spinner when navigation completes (success, cancel, or error)
          // But only if we're not on login page
          if (!this.router.url.includes('login')) {
            this.loadingService.hide();
          }
        }
      });
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    // Ensure spinner is hidden when component is destroyed
    this.loadingService.hide();
  }
}
